import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import authService from "../services/auth.service";
import "./AuthCallback.css";
import { useTranslation } from "react-i18next";

const AuthCallback = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // 'loading', 'success', 'error'
  const [errorMessage, setErrorMessage] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Mobil için URL'de gelen JWT'yi history'den temizle (web cookie kullanır)
        try {
          const params = new URLSearchParams(window.location.search);
          if (params.has("access_token")) {
            params.delete("access_token");
            const q = params.toString();
            window.history.replaceState(
              {},
              "",
              `${window.location.pathname}${q ? `?${q}` : ""}`
            );
          }
        } catch {
          /* ignore */
        }

        // Cookie'lerin set edilmesi için kısa bir süre bekle (max 3 deneme)
        let attempts = 0;
        const maxAttempts = 3;
        let success = false;

        while (attempts < maxAttempts && !success) {
          try {
            // Backend cookie'leri set etmiş olmalı, auth durumunu kontrol et
            await authService.handleGoogleCallback();
            success = true;
          } catch (error) {
            attempts++;
            if (attempts < maxAttempts) {
              // Cookie henüz hazır değilse kısa bir süre bekle
              await new Promise((resolve) => setTimeout(resolve, 300));
            } else {
              throw error;
            }
          }
        }

        console.log("Google callback successful");
        setStatus("success");

        const params = new URLSearchParams(window.location.search);
        const isNew = params.get("isNewUser") === "true";

        // Yeni kullanıcı ise bilgiyi ana sayfaya query ile taşı
        if (isNew) {
          navigate("/?isNewUser=true", { replace: true });
          return;
        }

        // Kısa bir gecikme ile ana sayfaya yönlendir (UX için)
        setTimeout(() => {
          navigate("/");
        }, 500);
      } catch (error) {
        setStatus("error");
        setErrorMessage(
          error.message || t("auth.genericError")
        );

        // Hata durumunda da kısa bir gecikme ile ana sayfaya yönlendir
        setTimeout(() => {
          navigate("/");
        }, 1500);
      }
    };

    handleCallback();
  }, [navigate, t]);

  const handleRetry = () => {
    navigate("/");
  };

  // Username popup akışı ana sayfaya taşındı

  return (
    <div className="auth-callback">
      <div className="auth-callback-container">
        {status === "loading" && (
          <div className="loading-state">
            <div className="spinner"></div>
            <h2>{t("auth.loggingIn")}</h2>
            <p>{t("auth.pleaseWait")}</p>
          </div>
        )}

        {status === "success" && (
          <div className="success-state">
            <div className="success-icon">✓</div>
            <h2>{t("auth.success")}</h2>
            <p>{t("auth.successDesc")}</p>
          </div>
        )}

        {status === "error" && (
          <div className="error-state">
            <div className="error-icon">✗</div>
            <h2>{t("auth.failed")}</h2>
            <p>{errorMessage}</p>
            <button onClick={handleRetry} className="retry-button">
              {t("auth.goHome")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
